import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/operator.png'


const _hoisted_1 = { class: "evse evse-details details" }
const _hoisted_2 = { class: "detail-top" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-header__block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "48"
  })
], -1)
const _hoisted_6 = { class: "info-tags" }
const _hoisted_7 = { class: "app-wrapper" }

import { computed } from 'vue'
import { ElMessageBox as MB, ElMessage } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import DetailHeader from '@/components/DetailHeader.vue'
import { getBrandInfo } from '@/api/operation'
import { checkMenuShow } from '@/store/tool'
import { Country } from '@/types/types'
import BrandUpsert, { OperationType } from './components/BrandUpsert.vue'
import BrandAuthOperators from './components/BrandAuthOperators.vue'
import OperatorTerminalApp from './components/OperatorTerminalApp.vue'
import OperatorNoti from './components/OperatorNoti.vue'
import OperatorPaymnetChannel from './components/OperatorPaymnetChannel.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'

import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent, ref, Ref } from 'vue'
const __default__ = defineComponent({
  name: 'BrandDetail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const { getCountry, getCurrency, getCurrencySymbol } = useProtocolEnums()

const route = useRoute()
const brandid = computed(function () {
  return route.params.id
})
const brand = ref<Record<string, any>>({
  id: brandid,
})
const showDialog = ref(false)
const showOperatorType: Ref<OperationType> = ref('edit')
const brandDetailLock = ref(false)
const currTab = ref('overview')

const handleTabChange = (tabname: any) => {
  console.log('tabname', tabname)
}
const editBrand = () => {
  showDialog.value = true
}

const loadData = async function () {
  getBrandInfo({
    id: brandid.value,
  })
    .then((res: any) => {
      brand.value = res.brand
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

const initData = async () => {
  await loadData()
}

initData()

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailHeader, {
        item: { name: brand.value.name }
      }, null, 8, ["item"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              (brand.value.operatorName)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(brand.value.operatorName), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (brand.value.currency)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getCurrency)(brand.value.currency)) + " " + _toDisplayString(_unref(getCurrencySymbol)(brand.value.currency)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Base.edit'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                disabled: !_ctx.$hasPermission('post'),
                type: "primary",
                icon: _unref(Edit),
                plain: "",
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (editBrand()))
              }, null, 8, ["disabled", "icon"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
      class: "detail-tabs",
      modelValue: currTab.value,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((currTab).value = $event)),
        handleTabChange
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Operation.authOpartor'),
            name: "overview",
            lazy: true,
            key: 'overview'
          }, {
            default: _withCtx(() => [
              _createVNode(BrandAuthOperators, {
                brandId: brand.value.id
              }, null, 8, ["brandId"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'brandAuthList']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Base.terminalApp'),
            name: "app",
            lazy: true,
            key: 'app'
          }, {
            default: _withCtx(() => [
              _createVNode(OperatorTerminalApp, {
                brandId: brand.value.id,
                style: {"padding-left":"0px","padding-right":"0px"}
              }, null, 8, ["brandId"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'brandApp']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Base.notiConfig'),
            name: "noti",
            lazy: true,
            key: 'noti'
          }, {
            default: _withCtx(() => [
              _createVNode(OperatorNoti, {
                brandId: brand.value.id,
                operatorId: brand.value.operatorID,
                style: {"padding-left":"0px","padding-right":"0px"}
              }, null, 8, ["brandId", "operatorId"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'brandNoti']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Base.paymentChannel'),
            name: "payment_channel",
            lazy: true,
            key: 'payment_channel'
          }, {
            default: _withCtx(() => [
              _createVNode(OperatorPaymnetChannel, {
                operatorId: brand.value.operatorID,
                style: {"padding-left":"0px","padding-right":"0px"}
              }, null, 8, ["operatorId"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'paymentChannel']
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])), [
      [
        _directive_loading,
        brandDetailLock.value,
        void 0,
        { lock: true }
      ]
    ]),
    _createVNode(BrandUpsert, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
      operationType: showOperatorType.value,
      info: brand.value,
      onSubmitted: loadData
    }, null, 8, ["modelValue", "operationType", "info"])
  ]))
}
}

})